<template>
  <div class="mobile-header">
    <div class="header-left">
      <div 
        v-if="showBack" 
        class="back-button"
        @click="handleBack"
      >
        <img 
          :src="backIcon || defaultBackIcon" 
          alt="back" 
          class="back-icon"
        />
      </div>
    </div>
    
    <div class="header-center">
      <h1 class="header-title">{{ title }}</h1>
    </div>
    
    <div class="header-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHeader',
  props: {
    // 标题文本
    title: {
      type: String,
      default: ''
    },
    // 是否显示返回按钮
    showBack: {
      type: Boolean,
      default: true
    },
    // 自定义返回图标
    backIcon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 默认返回图标（可以是本地图片或者SVG）
      defaultBackIcon: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDE4TDkgMTJMMTUgNiIgc3Ryb2tlPSIjMzMzIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K'
    }
  },
  methods: {
    handleBack() {
      // 触发自定义事件，如果没有监听则执行默认返回
      if (this.$listeners.back) {
        this.$emit('back')
      } else {
        // 默认返回行为
        if (this.$router && this.$router.go) {
          this.$router.go(-1)
        } else {
          window.history.back()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px;
  background: #FFFFFF;
  border-bottom: 1px solid #F0F0F0;
  position: relative;

  .header-left {
    flex: 0 0 auto;
    display: flex;
    align-items: center;

    .back-button {
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 50%;

      &:active {
        background-color: #F5F5F5;
      }

      .back-icon {
        width: 48px;
        height: 48px;
      }
    }
  }

  .header-center {
    flex: 1;
    display: flex;
    justify-content: center;
    pointer-events: none;
    margin-left: -24px;

    .header-title {
        font-family: DiDiSans-Pro-Medium;
        font-size: 36px;
        color: #0B0B0D;
        text-align: center;
        font-weight: 500;
    }
  }

  .header-right {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }
}
</style> 